export class CustomTerm {
  type: 'contains' | 'exact';
  term: string;
}
